
import axios from '../common/axiosHttp.js'
import JSEncrypt from 'jsencrypt'
import md5 from 'js-md5'
import Vue from 'vue';
import router from'../router'
axios.defaults.baseURL = ''

const apiUrl = {

//  xnmlUrl: 'http://localhost:8668/trialWapApi',
//  xnmlWriteUrl: 'http://localhost:8668/trialWriteApi', 
//  uploadUrl:'http://localhost:8668/wapUploadImage',
//  downCertApi:'http://localhost:8668/trialWapApi/downCertApi'

 xnmlUrl: 'http://wap.ptty.com.cn/trialWapApi',
 xnmlWriteUrl: 'http://wap.ptty.com.cn/trialWriteApi',
 uploadUrl:'http://wap.ptty.com.cn/wapUploadImage',
 downCertApi:'http://wap.ptty.com.cn/trialWapApi/downCertApi'

}

// http请求工具包
const handler = {
  paramData:{
    headerData:{
      ssid:'',
      op:'',//反射名称
      methodName:'',//对应的方法名
    },
    busData:{},//参数内容
  },
  // 发送Post请求，公共方法
  sendPost () { // 
    
    var loading='';
    var requestUrl='';
    var isLoadingShow=false;
    requestUrl=apiUrl.xnmlUrl;
      if(this.paramData.headerData.op==='trialItemGl'){
        if(this.paramData.busData.isjl==='1'){
          isLoadingShow=true;
        }
        else{
          isLoadingShow=false;
        }
      }else{
        isLoadingShow=true;
      }

      window.document.getElementById('LoadingComId').style.display = 'block'
      
    

    var paramJson = JSON.stringify(this.paramData)
    let Base64 = require('js-base64').Base64
    let baseStr = Base64.encode(paramJson)

    // //var ryInfoStr = localStorage.getItem("ryInfo");
    // //var TELEN='';
    // if (ryInfoStr === undefined ||ryInfoStr===null|| ryInfoStr.length === 0) {
    // }else{
    //   var ryInfo=JSON.parse(ryInfoStr)
    //   if(ryInfo.isLogin){
    //     TELEN=ryInfo.TELEN;
    //   }
      
    // }
    var sendParam = {
      paramData: baseStr, 
      mac: md5(baseStr + 'trialSystem000000000001')
    }
    
    let paramBase64=Base64.encode(JSON.stringify(sendParam));
    return new Promise((resolve, reject) => {
      axios.post(requestUrl, paramBase64)
        .then(response => {
          if(this.paramData.headerData.op==='login'){}
          else{
              //成功回调函数停止加载
              window.document.getElementById('LoadingComId').style.display = 'none'
          }
          var data=response.data;
          // alert('util返回：'+JSON.stringify(data))
          if (data.code === '-1') {
            //window.location.href = '/loginIndex'
            router.push({ path: "/loginIndex" });
          } else {
            resolve(data)
          }
        }, err => {
          //成功回调函数停止加载
          if(this.paramData.headerData.op==='login'){}
          else{
                      //成功回调函数停止加载
              window.document.getElementById('LoadingComId').style.display = 'none'
            
          }
          // Vue.prototype.$notify({
          //   type: "danger",
          //   message: "系统升级，请稍后再试",
          //   duration: 6000
          // });
          // alert('网络错误' + JSON.stringify(err))
        })
    })
  },
  sendDownCertPost () { // 
    
    var loading='';
    var requestUrl='';
    var isLoadingShow=false;
    requestUrl=apiUrl.downCertApi;
      if(this.paramData.headerData.op==='trialItemGl'){
        if(this.paramData.busData.isjl==='1'){
          isLoadingShow=true;
        }
        else{
          isLoadingShow=false;
        }
      }else{
        isLoadingShow=true;
      }

      window.document.getElementById('LoadingComId').style.display = 'block'
      
    

    var paramJson = JSON.stringify(this.paramData)
    let Base64 = require('js-base64').Base64
    let baseStr = Base64.encode(paramJson)

    // //var ryInfoStr = localStorage.getItem("ryInfo");
    // //var TELEN='';
    // if (ryInfoStr === undefined ||ryInfoStr===null|| ryInfoStr.length === 0) {
    // }else{
    //   var ryInfo=JSON.parse(ryInfoStr)
    //   if(ryInfo.isLogin){
    //     TELEN=ryInfo.TELEN;
    //   }
      
    // }
    var sendParam = {
      paramData: baseStr, 
      mac: md5(baseStr + 'trialSystem000000000001')
    }
    
    let paramBase64=Base64.encode(JSON.stringify(sendParam));
    return new Promise((resolve, reject) => {
      axios.post(requestUrl, paramBase64)
        .then(response => {
          if(this.paramData.headerData.op==='login'){}
          else{
              //成功回调函数停止加载
              window.document.getElementById('LoadingComId').style.display = 'none'
          }
          var data=response.data;
          // alert('util返回：'+JSON.stringify(data))
          if (data.code === '-1') {
            //window.location.href = '/loginIndex'
            router.push({ path: "/loginIndex" });
          } else {
            resolve(data)
          }
        }, err => {
          //成功回调函数停止加载
          if(this.paramData.headerData.op==='login'){}
          else{
                      //成功回调函数停止加载
              window.document.getElementById('LoadingComId').style.display = 'none'
            
          }
          // Vue.prototype.$notify({
          //   type: "danger",
          //   message: "系统升级，请稍后再试",
          //   duration: 6000
          // });
          // alert('网络错误' + JSON.stringify(err))
        })
    })
  },
  //填出场名单独立方法
  sendWritePost () { // 
    
    var loading='';
    var requestUrl='';
    var isLoadingShow=false;
    requestUrl=apiUrl.xnmlWriteUrl;
      if(this.paramData.headerData.op==='trialItemGl'){
        if(this.paramData.busData.isjl==='1'){
          isLoadingShow=true;
        }
        else{
          isLoadingShow=false;
        }
      }else{
        isLoadingShow=true;
      }

      window.document.getElementById('LoadingComId').style.display = 'block'
      
    

    var paramJson = JSON.stringify(this.paramData)
    let Base64 = require('js-base64').Base64
    let baseStr = Base64.encode(paramJson);
    
    var sendParam = {
      paramData: baseStr, 
      mac: md5(baseStr + 'trialSystem000000000001')
    }
    
    let paramBase64=Base64.encode(JSON.stringify(sendParam));
    return new Promise((resolve, reject) => {
      axios.post(requestUrl, paramBase64)
        .then(response => {
          if(this.paramData.headerData.op==='login'){}
          else{
              //成功回调函数停止加载
              window.document.getElementById('LoadingComId').style.display = 'none'
          }
          var data=response.data;
          // alert('util返回：'+JSON.stringify(data))
          if (data.code === '-1') {
            //window.location.href = '/loginIndex'
            router.push({ path: "/loginIndex" });
          } else {
            resolve(data)
          }
        }, err => {
          //成功回调函数停止加载
          if(this.paramData.headerData.op==='login'){}
          else{
                      //成功回调函数停止加载
              window.document.getElementById('LoadingComId').style.display = 'none'
            
          }
          // Vue.prototype.$notify({
          //   type: "danger",
          //   message: "系统升级，请稍后再试",
          //   duration: 6000
          // });
          // alert('网络错误' + JSON.stringify(err))
        })
    })
  },
  sendPostNoLoading () { 
    var requestUrl=apiUrl.xnmlUrl;

    var paramJson = JSON.stringify(this.paramData)
    let Base64 = require('js-base64').Base64
    let baseStr = Base64.encode(paramJson)
    var sendParam = {
      paramData: baseStr, 
      mac: md5(baseStr + 'trialSystem000000000001')
    }
    
    let paramBase64=Base64.encode(JSON.stringify(sendParam));
    return new Promise((resolve, reject) => {
      axios.post(requestUrl, paramBase64)
        .then(response => {
          if(this.paramData.headerData.op==='login'){}
          else{     
          }
          var data=response.data;
          if (data.code === '-1') {
            //window.location.href = '/loginIndex'
            router.push({ path: "/loginIndex" });
          } else {
            resolve(data)
          }
        }, err => {
          //成功回调函数停止加载
          if(this.paramData.headerData.op==='login'){}
          else{
            
          }
          // Vue.prototype.$notify({
          //   type: "danger",
          //   message: "系统升级，请稍后再试",
          //   duration: 6000
          // });
        })
    })
  },
  // 转换Json中key的大小写  type：0 大写  type：1 首字母大写  type：2 全部小写
  jsonToKey (json, type) {
    for (var key in json) {
      var item = json[key]
      delete (json[key])
      switch (type) {
        case 0:
          // key值全部大写
          json[key.toLocaleUpperCase()] = item
          break
        case 1:
          // key值首字母大写，其余小写
          json[key.substring(0, 1).toLocaleUpperCase() + key.substring(1).toLocaleLowerCase()] = item
          break
        default:
          // 默认key值全部小写
          json[key.toLocaleLowerCase()] = item
          break
      }
    }
    return json
  },
  // rsa公钥加密
  rsaEn (str) {
    // MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA2ditw1VU2oXKdRs3eHKCennx97eg+/eH6rsu3T1EccDNKBvCCbS3tvmq++sfgTVuuQkYhQuce+yxpJFUuyx2FIF8FaIiOembb8Q9pBT2ds1LD7kzydXhyydOQhjWArAjY0qwmTpq6y7kwsgtH6m6rde4oXw5P2Pz1CW2QnaFHQXrRj0Q2KUwaS401UUhpzdONY0VWRTCsqoc5+ohSBQr8C//MnVUmbUjDMNUn4002serTAzAeWvmmiGvzu5oVhBLmZHwBs97YRDiSgROo8wZmQBoBQOxmNN7KfhqhnFNRYp7J09/1lc6UVj5cYzGMbRB6Pzxr7Ja2P1eQsDtWCi3TwIDAQAB
    // MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQDZ2K3DVVTahcp1Gzd4coJ6efH3t6D794fquy7dPURxwM0oG8IJtLe2+ar76x+BNW65CRiFC5x77LGkkVS7LHYUgXwVoiI56ZtvxD2kFPZ2zUsPuTPJ1eHLJ05CGNYCsCNjSrCZOmrrLuTCyC0fqbqt17ihfDk/Y/PUJbZCdoUdBetGPRDYpTBpLjTVRSGnN041jRVZFMKyqhzn6iFIFCvwL/8ydVSZtSMMw1SfjTTax6tMDMB5a+aaIa/O7mhWEEuZkfAGz3thEOJKBE6jzBmZAGgFA7GY03sp+GqGcU1FinsnT3/WVzpRWPlxjMYxtEHo/PGvslrY/V5CwO1YKLdPAgMBAAECggEAaVyMBipyRNJqriMAvCeeBcCPEAFnQhZhTV1E+EoWnXHjh9+NBIa8SCoO0ZLRhPuj1qiYjFimUaWT8YU81t5VKevKaOgm552dyPu/2GkvHxyBjlRDwP3KHCihiARdFaW9J9vK+AEyDxd6Gt8YO/UqTcRFDw123rroBhZLRW/vR65di8gKnQ1QbWEsO+IcYENdi9s05Y/7mzw+DJCFndcj+I+scf3H9C+ShC2dj4sk5Zdu3qk6+HUCRMw1WnuJeY2lyH4YNWun0oIRobNgbVmJDRKFIkeY8L9MJ1JZVvubOpdQa838aN/+HD6A1ck/UA657WKcm+r6KyB6fMR5XhQPCQKBgQD2i1a6k9iL1o0cQH0wWNe3zZ6Q2qzf9CHipBOVxAeW4xvpWHE91QGynxBh3DnpUFMCT4JSDm3L7Kv5wfV9mrcZBvxQJPgpxOb4Nw3TJti3oPz69yxBgNKEebT7tx/o+5/67Z1+1qvU3LSjg3epFHxI6kL+vbG47wB1YdnYweDpRQKBgQDiM5LdCkUPKRTBFpl37gwgdJLJde0tsTL4VIkdRu+5/Ln54J7mNG03dYYohMqnWzjJFOYJpGiN6g3B8ycZOjRh2/XRWLAAJCwkb8Dck90tXrFsg7paSuZYKJMYBoNTrpGYTvcpOH4J+LQXnA6gpSdJaV0gSlq3flbmn4pBpCcFgwKBgDV6tC10tJxgxetC8eTy4Jg2Ohch2C4cPt1yyezKwPqx+PP9A1NuSRf9+QfBRa6eheMSbCpwhtCdXhCnSiEc1mrPYRvhaRNmatOc3ZrX6lqqyTWHOEpdL00dOW0ApCNdsa40rN0+o7dgyK5Pbj12/B608iNf8pUzAt5zg1XJeIghAoGAL1yREYsG7qexWsR6mavUCi+eVGRGptyFSY2Zr/GcXBrYbcNkQdsUSxpmXrF/JQ9qkl+30qkD40LwYn2g4B1Zvmupyo2BPGZWf8KOZSDonIlJKOlj6WfpVugX9F3YvXq9rWBLS+wyJ7BVNOROA8DQuwQ+pXYsDGN9mogpEJloOjUCgYEA4o+DxUiOyuDSRJJYWl2lII3D+7symuexf+tpqsKR7w434e3eODiXgy/TzPzV58rbXtUeKnKHLrYgooOq8J9n8f+7pf0SBUdbvRYMtzYxt8Gxyk7uj3zQndpbNUylQWBhXxiTMi2i6iaxChZcGsVdauC+Qe87E/Cgq/S6PFw2t+o=
    const pubKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA2ditw1VU2oXKdRs3eHKCennx97eg+/eH6rsu3T1EccDNKBvCCbS3tvmq++sfgTVuuQkYhQuce+yxpJFUuyx2FIF8FaIiOembb8Q9pBT2ds1LD7kzydXhyydOQhjWArAjY0qwmTpq6y7kwsgtH6m6rde4oXw5P2Pz1CW2QnaFHQXrRj0Q2KUwaS401UUhpzdONY0VWRTCsqoc5+ohSBQr8C//MnVUmbUjDMNUn4002serTAzAeWvmmiGvzu5oVhBLmZHwBs97YRDiSgROo8wZmQBoBQOxmNN7KfhqhnFNRYp7J09/1lc6UVj5cYzGMbRB6Pzxr7Ja2P1eQsDtWCi3TwIDAQAB'// ES6 模板字符串 引用 rsa 公钥
    const encryptStr = new JSEncrypt()
    encryptStr.setPublicKey(pubKey) // 设置 加密公钥
    const data = encryptStr.encrypt(str.toString()) // 进行加密
    return data
  },
  getOpenId(fn){
    // // // 啦啦啦
    // // fn('39457146306a32694a36445256567233686a544649434a5a354232714659492f33766471706a4977584a303d');
    // //  return;
    // 66

    //  fn('39684774704c4d51555244356d4c477541334739797258417575504f67366d454547757862397a2b4d77513d--');
    //  return;
    

    var openIdEn = localStorage.getItem("openIdEn");
      if (
        openIdEn === undefined ||
        openIdEn === null ||
        openIdEn.length === 0||
        openIdEn==='465255654578797a502b303d'
      ) {
        openIdEn = "";
      }
      else{
        fn(openIdEn)
        return;
      }
    var code = new URLSearchParams(window.location.search).get("code");
    //alert('code:'+code);
    if (code === null || code === undefined || code === "") {
      let urlNow = encodeURIComponent(window.location.href);
      //snsapi_userinfo 非静默授权用户有感知 snsapi_base 静默授权用户无感知
      let appid = "wx98a0a8c004d720f5";
      let scope = "snsapi_base";
      let url =
        "https://open.weixin.qq.com" +
        "/connect/oauth2/authorize?appid=" +
        appid +
        "&redirect_uri=" +
        urlNow +
        "&response_type=code&scope=" +
        scope +
        "#wechat_redirect";
      window.location.href = url;
    } else {
      var openIdEn = localStorage.getItem("openIdEn");
      if (
        openIdEn === undefined ||
        openIdEn === null ||
        openIdEn.length === 0
      ) {
        openIdEn = "";
      }
      //获取OpenId
      var busData = {
        code: code,
        openIdEn: openIdEn
      };
      this.paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "getOpenId" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.sendPost().then(data => {
        //alert(JSON.stringify(data))
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        let openIdEn = data.content.OPENIDEN;
        localStorage.setItem("openIdEn", openIdEn);
        fn(openIdEn)
        if (data.code === "SUCCESS") {
          localStorage.setItem("ryInfo", JSON.stringify(data.content));
        }
        var newUrl=this.getDelCodeNewUrl(window.location.href, ['code'])
        window.location.href = newUrl
      });
    }
  },
  //获取删除code后的新的url地址
  getDelCodeNewUrl(url, params){
    /**
       * 删除URL中指定search参数,会将参数值一起删除
       * @param {string} url 地址字符串
       * @param {array} aParam 要删除的参数key数组，如['name','age']
       * @return {string} 返回新URL字符串
       */
    for (var index = 0; index < params.length; index++) {
      var item = params[index];
      var fromIndex = url.indexOf(item + "="); //必须加=号，避免参数值中包含item字符串
      if (fromIndex !== -1) {
        // 通过url特殊符号，计算出=号后面的的字符数，用于生成replace正则
        var startIndex = url.indexOf("=", fromIndex);
        var endIndex = url.indexOf("&", fromIndex);
        var hashIndex = url.indexOf("#", fromIndex);

        var reg = "";
        if (endIndex !== -1) {
          // 后面还有search参数的情况
          var num = endIndex - startIndex;
          reg = new RegExp(item + "=.{" + num + "}");
          url = url.replace(reg, "");
        } else if (hashIndex !== -1) {
          // 有hash参数的情况
          var num = hashIndex - startIndex - 1;
          reg = new RegExp("&?" + item + "=.{" + num + "}");
          url = url.replace(reg, "");
        } else {
          // search参数在最后或只有一个参数的情况
          reg = new RegExp("&?" + item + "=.+");
          url = url.replace(reg, "");
        }
      }
    }
    var noSearchParam = url.indexOf("=");
    if (noSearchParam === -1) {
      url = url.replace(/\?/, ""); // 如果已经没有参数，删除？号
    }
    return url;
  },
  getLogin(){
    var ryInfoStr = localStorage.getItem("ryInfo");
    if (ryInfoStr === undefined ||ryInfoStr===null|| ryInfoStr.length === 0) {
       ryInfo= {
        NIC: "点击登录",
        TEL: "",
        TELEN: "",
        isLogin:false,
      }
      return ryInfo
    }else{
      var ryInfo=JSON.parse(ryInfoStr)
      return ryInfo;
    }
   
  },
  //上传图片
  uploadImg(file,uploadType) {
    file.status = "uploading";
    file.message = "上传中...";
    const formData = new FormData();
    formData.append("uploadType",uploadType);
    formData.append("file", file.file);
    return new Promise((resolve, reject) => {
      axios
        .post(apiUrl.uploadUrl, formData, {
          headers: this.headers
        })
        .then(res => {
          if (res.data) {
            if (res.data.isSuccess) {
              file.status = "success";
              file.message = "";
              file.url = res.data.uploadUrl;
            }
            resolve(res.data);
          }
        })
        .catch(err => {
          alert('上传失败：'+JSON.stringify(err))
        });
    });
  },
  formatDate(date, args) {
    var dt = date;
            if(args == 'yyyy-M-d') {// yyyy-M-d
            let year = dt.getFullYear();
            let month = dt.getMonth() + 1;
            let date = dt.getDate();
            return `${year}-${month}-${date}`;
        } else if(args == 'yyyy-M-d H:m:s'){// yyyy-M-d H:m:s
            let year = dt.getFullYear();
            let month = dt.getMonth() + 1;
            let date = dt.getDate();
            let hour = dt.getHours();
            let minute = dt.getMinutes();
            let second = dt.getSeconds();
            return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
        } else if(args == 'yyyy-MM-dd') {// yyyy-MM-dd
            let year = dt.getFullYear();
            let month = (dt.getMonth() + 1).toString().padStart(2,'0');
            let date = dt.getDate().toString().padStart(2,'0');
            return `${year}-${month}-${date}`;
        } else if(args == 'yyyy年MM月dd日') {// yyyy-MM-dd
          let year = dt.getFullYear();
          let month = (dt.getMonth() + 1).toString().padStart(2,'0');
          let date = dt.getDate().toString().padStart(2,'0');
          return `${year}年${month}月${date}日`;
        }else {// yyyy-MM-dd HH:mm:ss
            let year = dt.getFullYear();
            let month = (dt.getMonth() + 1).toString().padStart(2,'0');
            let date = dt.getDate().toString().padStart(2,'0');
            let hour = dt.getHours().toString().padStart(2,'0');
            let minute = dt.getMinutes().toString().padStart(2,'0');
            let second = dt.getSeconds().toString().padStart(2,'0');
            return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
        }
  },
  verifySign(paramStr){
    var key='lZZSkSzPDRVv6PLW4TPluSVaVXtAJUyA';
    var array=paramStr.split('▩')
    var jsonMsg=array[0];
    var sign=array[1].toUpperCase();
    var res={
      isSign:false,
      jsonMsg:jsonMsg
    };
    var mySign=md5(jsonMsg+key).toUpperCase();
    res.isSign=mySign===sign;
    res.jsonMsg=jsonMsg;
    return res;
  },
  tencentAdInitSdk(){
    // 如果已经加载过，直接返回
    if (document.querySelector('script[src*="gdtimg.com"]')) {
       return;
    }

    const script = document.createElement("script");
    script.async = true;
    script.src =
      "https://qzs.gdtimg.com/union/res/union_sdk/page/h5_sdk/i.js";
    const head = document.head;
    head.insertBefore(script, head.firstChild);
  },
  async loadAdHandler(domId) {
  // 1. 开启 SDK 调试模式（重要！会在控制台打 [GDT] 日志）
  window.GDT_DEBUG = true;

  // 2. 等待 SDK 真正加载好
  await this.tencentAdInitSdk();

  // 3. 必须先初始化数组
  window.TencentGDT = window.TencentGDT || [];
  
  let placeIdArray=['9312720434062143','8302021414991547','5362724494398693','3302825444997627','3312423474491712','1362826494596788'];
  
  // 随机下标
  let randomIndex = Math.floor(Math.random() * placeIdArray.length);
  // 随机项
  let placement_id = placeIdArray[randomIndex];
  
  console.log('👉 准备 push 广告配置', {
    app_id: '1218010986',
    placement_id: placement_id,
    domId
  });

  // 4. 官方标准写法：只 push 一次，不要重复 push
  window.TencentGDT.push({
    app_id: '1218010986',
    placement_id: placement_id,
    type: 'native',
    count: 3,
    // 官方回调只有 onComplete，没有 onError！
    onComplete: (res) => {
      console.log('✅ onComplete 触发', res);

      // 情况 A：返回空数组 = 没广告（正常）
      if (!Array.isArray(res) || res.length === 0) {
        console.warn('⚠️ 广告返回空数组（无填充）');
        return;
      }

      // 情况 B：正常返回广告
      let randomIndex = Math.floor(Math.random() * res.length);
      let adData = res[randomIndex];
      if (adData) {
        try {
          window.TencentGDT.NATIVE.renderAd(adData, domId);
          console.log('🎯 渲染成功', domId);
        } catch (e) {
          console.error('❌ renderAd 失败', e);
        }
      }
    }
    // 注意：H5 SDK 原生广告 **没有 onError 回调**！
  });
}


}

//压缩图片
/**
 * @description: 图片压缩
 * @param {*} img
 * @return {*}
 */
const compressImg = (img) => {
  let canvas = document.createElement('canvas')
  let ctx = canvas.getContext('2d')
  let tCanvas = document.createElement('canvas')
  let tctx = tCanvas.getContext('2d')
  let width = img.width
  let height = img.height
  //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
  let ratio
  if ((ratio = (width * height) / 4000000) > 1) {
    console.log('大于400万像素')
    ratio = Math.sqrt(ratio)
    width /= ratio
    height /= ratio
  } else {
    ratio = 1
  }
  canvas.width = width
  canvas.height = height
  //    铺底色
  ctx.fillStyle = '#fff'
  ctx.fillRect(0, 0, canvas.width, canvas.height)
  //如果图片像素大于100万则使用瓦片绘制
  let count
  if ((count = (width * height) / 1000000) > 1) {
    console.log('超过100W像素')
    count = ~~(Math.sqrt(count) + 1) //计算要分成多少块瓦片
    // 计算每块瓦片的宽和高
    let nw = ~~(width / count)
    let nh = ~~(height / count)
    tCanvas.width = nw
    tCanvas.height = nh
    for (let i = 0; i < count; i++) {
      for (let j = 0; j < count; j++) {
        tctx.drawImage(
          img,
          i * nw * ratio,
          j * nh * ratio,
          nw * ratio,
          nh * ratio,
          0,
          0,
          nw,
          nh
        )
        ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh)
      }
    }
  } else {
    ctx.drawImage(img, 0, 0, width, height)
  }
  //进行最小压缩
  let minData = canvas.toDataURL('image/jpeg', 0.1)
  tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0
  return minData
}

export default { handler, apiUrl,compressImg }



// WEBPACK FOOTER //
// ./src/common/util.js